import { HOME_PATH } from '../../constants'

export const reloadHome = () => {
  window.location.replace(HOME_PATH)
}
